export const MESSAGE_ERROR = 'error';
export const MESSAGE_INFO = 'info';
export const MESSAGE_IMPORTANT = 'important';
